import { cmsData } from './cmsData';

export function cms(id) {
  return cmsData[id];
}
